import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Select",
  "use": "Select-usage",
  "viewBox": "0 0 32 25",
  "content": "<symbol viewBox=\"0 0 32 25\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Select\">\n<path d=\"M10.1632 19.2619L3.86238 12.961C3.15134 12.25 1.99851 12.25 1.28746 12.961V12.961C0.576416 13.6721 0.576416 14.8249 1.28746 15.536L10.1632 24.4117L30.7125 3.86238C31.4236 3.15134 31.4236 1.99851 30.7125 1.28746V1.28746C30.0015 0.576415 28.8487 0.576416 28.1376 1.28746L10.1632 19.2619Z\" fill=\"black\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol